import script from "./indexBackup.vue?vue&type=script&setup=true&lang=js"
export * from "./indexBackup.vue?vue&type=script&setup=true&lang=js"

import "./indexBackup.vue?vue&type=style&index=0&id=878d4322&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-878d4322"]])

export default __exports__